/* eslint-disable camelcase */
import { Message as $message } from 'element-ui';
import router from '../vueRouter';
import ExpError from '@/modules/FPKG-20000-Util/library/ExpError';
import $i18n from '@/modules/FPKG-20000-Util/lang'; // 取得多國文本
import timeZones from '@/modules/FPKG-20000-Util/const/timeZones';
import regions from '@/modules/FPKG-20000-Util/const/regions'; // 取得所有地區的代碼


/** 取得本地端地區代號 */
const CUR_REGION = window.localStorage.getItem('locale');
let REGION_F: string = 'zh_CN'; // 宣告容器
// 將格式化的代號放入容器 否則回傳失敗並且丟回首頁
if (CUR_REGION && typeof CUR_REGION === 'string') {
  REGION_F = CUR_REGION;
} else {
  $message.error('Region not exist');
  router.push('/');
  const err = new ExpError('Region not exist', -1);
  throw err;
}

/** 取得本站宣告的地區資訊，或是目標地區資訊 */
class Locale {
  public curRegion: string = REGION_F

  public timeZones = timeZones;

  constructor(locale?: string | number) {
    if (typeof locale === 'string') {
      this.curRegion = locale;
    } else if (typeof locale === 'number') {
      const filted_region = regions.filter(r => r.p12_ron_id === locale); // 篩選出該ID的地區
      /** 若有結果，將其放上 */
      if (filted_region.length > 0) {
        this.curRegion = filted_region[0].p12_ron_code;
      }
    }
  }

  /** 回傳時區，**目前用不到** */
  public get zone(): number {
    // 檢查該地區是否存在於前端總表 ** 記得轉大寫 **
    const EXISTS = Object.prototype.hasOwnProperty.call(this.timeZones, this.curRegion);
    const key = this.curRegion.toUpperCase();
    if (EXISTS) { return timeZones[key]; }
    return 8;
  }

  /** 回傳該地區名稱的多國語系結果 */
  public get name(): string {
    const path = this.curRegion;
    return $i18n.tc(`Util.region.${path}`);
  }
}

export default Locale;
